import React, { useEffect, useState } from 'react';
const TOTAL_SECONDS = 17 * 60 + 34; // 00:17:34

type Props = {
  tone?: 'dark' | 'light';
};
function pad(n: number) {
  return String(n).padStart(2, '0');
}
export function Countdown({
  tone = 'dark'
}: Props) {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const cells = [{
    value: pad(hours),
    label: 'Ore'
  }, {
    value: pad(minutes),
    label: 'Min'
  }, {
    value: pad(seconds),
    label: 'Sec'
  }];
  const isDark = tone === 'dark';
  return <div className="w-full" data-id="element-22" data-mp="10dmy3kg9of7h">
      <p className={`text-center text-[11px] font-bold uppercase tracking-[0.18em] ${isDark ? 'text-white/70' : 'text-ink/55'}`} data-id="element-23" data-mp="10a8te5k4rtwv">
        Questa offerta scade tra
      </p>
      <div className="mt-3 flex items-center justify-center gap-2 sm:gap-3" data-id="element-24" data-mp="xytt856ieh0g">
        {cells.map(cell => <div key={cell.label} className={`flex min-w-[68px] flex-col items-center rounded-xl px-3 py-2 sm:min-w-[84px] sm:py-3 ${isDark ? 'bg-white/10 ring-1 ring-white/20' : 'bg-white ring-1 ring-ink/10'}`} data-id="element-25" data-mp="17qzvc7qh6etd">
            <span className={`font-display text-3xl font-black tabular-nums leading-none sm:text-4xl ${isDark ? 'text-white' : 'text-plum-deep'}`} data-id="element-26" data-mp="f4etuegacmc3">
              {cell.value}
            </span>
            <span className={`mt-1 text-[10px] font-bold uppercase tracking-[0.16em] ${isDark ? 'text-white/60' : 'text-ink/50'}`} data-id="element-27" data-mp="k15jnthw6wap">
              {cell.label}
            </span>
          </div>)}
      </div>
    </div>;
}